// Libs
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavLink } from 'o2web-react-core';

// Actions
import navActions from '../../../actions/nav';

// Styles
import './styles.scss';

function Breadcrumbs(props, { t }) {
  const {
    contentType,
    title,
    mainNav,
  } = props;
  let contentTypeLink;
  if (contentType && mainNav.length) {
    // Using icon to find link because it has the same key as the content type
    contentTypeLink = mainNav.find(link => link.icon === contentType);
  }
  const {
    title: contentTypeTitle,
    path,
    lang,
  } = contentTypeLink || {};
  return (
    <nav className="breadcrumbs">
      <ol>
        <li><NavLink to={`/${lang || 'fr'}`}>{t('nav.home')}</NavLink></li>
        {contentTypeLink &&
          <li>
            <NavLink to={`${lang}${path}`}>
              {contentTypeTitle}
            </NavLink>
          </li>
        }
        {title &&
          <li>{title}</li>
        }
      </ol>
    </nav>
  );
}

Breadcrumbs.propTypes = {
  contentType: PropTypes.oneOf(['activity', 'artwork', 'resource']),
  title: PropTypes.string,
  mainNav: PropTypes.array.isRequired,
};
Breadcrumbs.defaultProps = {
  contentType: null,
  title: null,
};
Breadcrumbs.contextTypes = {
  t: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    mainNav: state.nav.mainNav,
  };
}

export default withRouter(connect(mapStateToProps, navActions)(Breadcrumbs));



// WEBPACK FOOTER //
// ./src/app/components/tools/breadcrumbs/Breadcrumbs.js